/* eslint-disable consistent-return */

// Front end selector for the programs cards.
const programElement = document.querySelector('.twoyou-programs-select-degree');
const interestElement = document.querySelector('.twoyou-programs-select-degree-type');
const programCards = document.querySelectorAll('.twoyou-programs-selector-card-link');

const programsOptions = document.querySelectorAll('.twoyou-programs-select-degree option');
const interestOptions = document.querySelectorAll('.twoyou-programs-select-degree-type  option');

const programsContainer = document.querySelector('.twoyou-programs-selector-container');
let selectedProgram = programElement?.value;
let selectedInterest = interestElement?.value;

let showAllPrograms = true;
let showAllInterests = true;

function showCard(card) {
  card.classList.add('u-flex');
  card.classList.remove('u-hide');
}

function hideCard(card) {
  card.classList.remove('u-flex');
  card.classList.add('u-hide');
}

function resetOptions(options) {
  options.forEach(el => {
    el.removeAttribute('disabled');
  });
}

const availableOptions = [];
function updateInterestOptions() {
  const interestsToEnable = [];

  // Show All Options.
  if (selectedProgram === '') {
    return resetOptions(interestOptions);
  }

  // Get interests which match current program.
  availableOptions.forEach(optionPair => {
    Object.entries(optionPair).forEach(([interest, program]) => {
      if (interest.length === 0) {
        return;
      }
      if (selectedProgram === program && !interestsToEnable.includes(interest)) {
        interestsToEnable.push(interest);
      }
    });
  });

  // Disable other interests.
  interestOptions.forEach(el => {
    if (el.value.length === 0) {
      return;
    }
    if (!interestsToEnable.includes(el.value)) {
      el.setAttribute('disabled', 'disabled');
    }
  });
}

function updateProgramOptions() {
  const programsToEnable = [];

  // Show All Options.
  if (selectedInterest === '') {
    return resetOptions(programsOptions);
  }

  // Get programs which match current interest.
  availableOptions.forEach(optionPair => {
    Object.entries(optionPair).forEach(([interest, program]) => {
      if (program.length === 0) {
        return;
      }
      if (selectedInterest === interest && !programsToEnable.includes(program)) {
        programsToEnable.push(program);
      }
    });
  });

  // Disable other programs.
  programsOptions.forEach(el => {
    if (el.value.length === 0) {
      return;
    }
    if (!programsToEnable.includes(el.value)) {
      el.setAttribute('disabled', 'disabled');
    }
  });
}

function updateCards() {
  if (selectedProgram === '') {
    showAllPrograms = true;
  } else {
    showAllPrograms = false;
  }

  if (selectedInterest === '') {
    showAllInterests = true;
  } else {
    showAllInterests = false;
  }

  programCards.forEach(card => {
    const cardInterest = card.dataset.interest.trim().split(' ');
    const cardProgram = card.dataset.program.trim().split(' ');

    hideCard(card);
    // Filter by interests only
    if (showAllPrograms && !showAllInterests) {
      if (cardInterest.includes(selectedInterest)) {
        showCard(card);
      }
    }

    // Filter by programs only
    if (!showAllPrograms && showAllInterests) {
      if (cardProgram.includes(selectedProgram)) {
        showCard(card);
      }
    }

    // Filter by programs and interest
    if (!showAllPrograms && !showAllInterests) {
      if (cardInterest.includes(selectedInterest) && cardProgram.includes(selectedProgram)) {
        showCard(card);
      }
    }

    // Show all cards
    if (showAllPrograms && showAllInterests) {
      showCard(card);
    }
  });
}

if (typeof programsContainer !== 'undefined' && programsContainer !== null) {
  document.addEventListener('DOMContentLoaded', () => {
    programCards.forEach(el => {
      const interests = el.dataset.interest.trim().split(' ');
      const programs = el.dataset.program.trim().split(' ');
      const obj = {};
      interests.forEach(interest => {
        obj[interest] = programs?.[0];
      });
      availableOptions.push(obj);
    });

    updateInterestOptions();
    updateProgramOptions();
  });

  programElement.addEventListener('change', () => {
    selectedProgram = programElement.value;
    resetOptions(interestOptions);
    updateCards();
    updateInterestOptions();
  });

  interestElement.addEventListener('change', () => {
    selectedInterest = interestElement.value;
    resetOptions(programsOptions);
    updateCards();
    updateProgramOptions();
  });
}
